import EcoLink from 'eco-design/base/eco-link';
import FooterAccessibility from 'eco-design/section-layout/ef-nav-common/FooterComps/FooterAccessibility';
import './index.scss';

export default function FooterC1Links({ locale, list = {}, theme = 'black' }: { locale: string; list: any; theme: 'white' | 'black' | 'gray' }) {
    return (
        <>
            <div className={`footer-FooterC1Links footer-FooterC1Links-theme-${theme}`}>
                {list
                    ?.slice?.() // 复制一份防止改变原数组
                    .sort((a: any, b: any) => (a.sort ?? 0) - (b.sort ?? 0))
                    .map((item: any, index: number) => {
                        const obj = JSON.parse(item.content);
                        return (
                            <EcoLink
                                className="footer-FooterC1Links-item GtmModuleData-btn-href"
                                key={index}
                                href={obj?.redirectUrl}
                                aria-label={obj?.text}
                                target="_blank"
                                dataLayer={{
                                    __btn_id1: 'footer-FooterC1Links',
                                    __btn_id2: obj?.redirectUrl,
                                    __btn_type: 'href',
                                }}
                            >
                                {obj?.text}
                            </EcoLink>
                        );
                    })}
                <FooterAccessibility locale={locale} />
            </div>
        </>
    );
}
